import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getApiLanguage } from "src/services/commonLanguageHeader";
import {
  getConnectivityHeatmap,
  type ConnectivityHeatmapParams,
} from "src/services/connectivityHeatmapService";
import { useGeneralRefetchOverride } from "./general.queries";
import { QueryNames } from "./queries.constant";

export const useQueryGetConnectivityHeatmap = (
  params?: ConnectivityHeatmapParams,
  options: { enabled?: boolean } & Record<string, unknown> = {},
) => {
  const { i18n } = useTranslation();
  const language = getApiLanguage(i18n.language);
  const enabled =
    !!params?.unitId &&
    !!params.from &&
    !!params.to &&
    options.enabled !== false;

  return useGeneralRefetchOverride(
    useQuery({
      queryKey: [...QueryNames.connectivityHeatmap, params, language],
      queryFn: () =>
        getConnectivityHeatmap(params as ConnectivityHeatmapParams, language),
      enabled,
      select: (data) => data.data.response,
      retry: false,
      ...options,
    }),
    enabled,
  );
};
